/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const instanceTypeMappingCreateRequestSchema = z.object({
  itemTypeId: z.int(),
  sourceTypeId: z.string(),
});
